import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-white bg-blue-400 p-4 border-blue- border rounded" }, " Lütfen içe aktarım yapmadan önce, Excel veya CSV dosyasının doğru formatta olduğuna emin olun. Detaylı bilgileri, eğitimler bölümündeki videodan da alabilirsiniz. ", -1)
const _hoisted_2 = {
  key: 0,
  class: "ac-form-control"
}
const _hoisted_3 = {
  class: "single-line-label text-3xl my-4",
  for: "email"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "bottom-2 left-2 w-full h-full absolute" }, "?", -1)
const _hoisted_5 = ["onClick"]

import { ref } from "vue"
import { useGetAllMetas } from "../../mixins/metaManagement"
import fileUploadFlexible from "../reusable/fileUploadFlexible.vue"
import Multiselect from 'vue-multiselect'

import type { EMailTag } from "@/types"
import VueTooltip from "../reusable/VueTooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'mailImporter',
  emits: ["cancelled", "initiateImport"],
  setup(__props, { emit: __emit }) {

const emits = __emit
const uploadedFile = ref<File | null>(null)

const { metaList, isLoadingMeta } = useGetAllMetas("crm/EMailTags")

const tags = ref<EMailTag[]>([])

const updateFiles = (files: File[]) => {
    uploadedFile.value = files[0]
}

const initiateImport = () => {
    emits("initiateImport", {file: uploadedFile.value, tags: tags.value})
}

const cancel = () => {
    emits("cancelled")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", null, [
    _hoisted_1,
    _createVNode(fileUploadFlexible, {
      onFilesChanged: updateFiles,
      "single-file": true,
      allow: ['.xls', '.xlsx', '.csv'],
      class: "my-8"
    }, null, 8, ["allow"]),
    (!_unref(isLoadingMeta))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            _createTextVNode("Etiketler "),
            _createVNode(VueTooltip, { explanation: "Eğer maillerin tamamına eklemek istediğiniz bir etiket varsa, buradan ekleyebilirsiniz." }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(Multiselect), {
            class: "w-5/6 email-multiselect h-full border flex flex-col items-start justify-center relative !text-black mr-4",
            modelValue: tags.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tags).value = $event)),
            multiple: "",
            options: _unref(metaList),
            placeholder: "Eklemek istediğiniz etiketleri seçin",
            "track-by": "id",
            "select-label": "Seçmek için tıklayın",
            "deselect-label": "Seçimi kaldırmak için tıklayın",
            "selected-label": "Seçildi",
            label: "name"
          }, {
            tag: _withCtx(({option, remove}) => [
              _createElementVNode("span", {
                class: "custom-option",
                style: _normalizeStyle({'backgroundColor': option.color})
              }, [
                _createTextVNode(_toDisplayString(option.name) + " ", 1),
                _createElementVNode("span", {
                  class: "remove-option",
                  onClick: ($event: any) => (remove(option))
                }, "×", 8, _hoisted_5)
              ], 4)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", { class: "button-row justify-center flex gap-4 mt-4" }, [
      _createElementVNode("button", {
        onClick: initiateImport,
        class: "ac-primary-button"
      }, "İçe Aktar"),
      _createElementVNode("button", {
        onClick: cancel,
        class: "ac-secondary-button"
      }, "İptal")
    ])
  ]))
}
}

})